import React, { useState } from 'react'

import { isEmpty } from 'lodash'
import { Box, Button, CircularProgress, Tooltip } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import helpers from 'helpers'

// Envio do projeto para revisão. O service vem por prop, então o mesmo botão
// atende ao app e ao portal de convidados, nas telas de edição e visualização.
// A obrigatoriedade das respostas também é validada pelo backend no
// change_status, que devolve as questões pendentes na mensagem de erro.
const PrivacyByDesignSendToReviewButton = ({
  privacyByDesignId,
  service,
  questions = [],
  onSuccess = () => {},
  id,
}) => {
  const [isSending, setIsSending] = useState(false)

  const snackbar = useSnackbar()

  const { AWAITING_REVIEW_STATUS_LABEL } = constants.privacyByDesign
  const { ANSWERED_STATUS } = constants.privacyByDesignAnswer

  const areAllQuestionsAnswered =
    !isEmpty(questions) &&
    questions.every(
      (question) =>
        question.privacyByDesignAnswers?.[0]?.status === ANSWERED_STATUS,
    )

  const handleSendToReview = async () => {
    setIsSending(true)
    try {
      await service.changeStatus({
        privacyByDesignId,
        status: AWAITING_REVIEW_STATUS_LABEL,
      })

      snackbar.open({
        message: 'Projeto enviado para revisão!',
        variant: 'success',
      })

      onSuccess()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro, tente novamente',
        variant: 'error',
      })
    } finally {
      setIsSending(false)
    }
  }

  return (
    <Tooltip
      title={
        areAllQuestionsAnswered
          ? ''
          : 'Responda todas as questões do projeto para enviar para revisão'
      }
      arrow
    >
      {/* O Box é necessário porque um Button desabilitado não dispara os
          eventos que o Tooltip escuta. */}
      <Box>
        <Button
          id={id}
          color="primary"
          variant="contained"
          onClick={handleSendToReview}
          disabled={!areAllQuestionsAnswered || isSending}
          startIcon={
            isSending && <CircularProgress size={14} color="inherit" />
          }
        >
          Enviar para Revisão
        </Button>
      </Box>
    </Tooltip>
  )
}

export default PrivacyByDesignSendToReviewButton
